// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminAssetsValues = {
  values: {
    user: "ユーザー",
    public: "公開",
    tenant: "テナント",
    application: "アプリ",
    shared: "共有",
    sharedOwner: "共有",
    mySpace: "マイスペース",
    publicBranding: "公開ブランド資源",
    publicShared: "公開共有資源",
    sharedToPublic: "公開へ共有済み",
    privateOnly: "自分のみ表示",
    unlimited: "無制限",
    deletable: "削除可",
    protected: "保護中",
    unmanaged: "未統治",
    none: "なし",
    active: "有効",
    readonly: "読取専用",
    disabled: "無効",
    read: "読取",
    write: "書込",
    manage: "管理",
    ownerOnly: "所有者のみ",
    spaceAdmin: "空間管理者",
    platformAdmin: "プラットフォーム管理者",
    staff: "考務スタッフ",
    platformRole: "プラットフォームロール",
  },
} as const;
